export default {
  LABEL: 'label'
};